module.exports = __webpack_public_path__ + "russierenouvelables/img/pellet-map.d742b0f9.webp";